import React from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_COLLAPSED_WIDTH,
	SIDE_NAV_DARK,
	SIDE_NAV_LIGHT,
	NAV_TYPE_SIDE,
} from "constants/ThemeConstant";
import { Scrollbars } from "react-custom-scrollbars";
import MenuContent from "./MenuContent";
import SideNavFooter from "./SideNavFooter";
import SidebarLogo from "./SidebarLogo";
import "./side-nav-dimo.css";

const { Sider } = Layout;

export const SideNav = ({
	navCollapsed,
	sideNavTheme,
	routeInfo,
	hideGroupTitle,
	localization = true,
}) => {
	const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };
	const shellTheme = sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark";
	const isLightShell = shellTheme === "light";

	return (
		<Sider
			className={`side-nav side-nav--dimo ${
				isLightShell ? "side-nav--light" : "side-nav--dark"
			} ${sideNavTheme === SIDE_NAV_DARK ? "side-nav-dark" : ""}`}
			width={SIDE_NAV_WIDTH}
			collapsedWidth={SIDE_NAV_COLLAPSED_WIDTH}
			collapsed={navCollapsed}
			style={{
				height: "100vh",
				position: "fixed",
				top: 0,
				left: 0,
				boxShadow: "none",
				zIndex: 998,
				direction: "ltr",
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
				backgroundColor: isLightShell ? "#f8f9fb" : "#0f172a",
				borderRight: isLightShell
					? "1px solid rgba(0, 0, 0, 0.08)"
					: "1px solid #1e293b",
			}}
		>
			<div className="side-nav-inner">
				<div className="side-nav-brand">
					<SidebarLogo
						collapsed={navCollapsed}
						placement="side"
						logoType="light"
					/>
				</div>
				<div className="side-nav-scroll">
					<Scrollbars autoHide style={{ height: "100%" }}>
						<MenuContent type={NAV_TYPE_SIDE} {...props} />
					</Scrollbars>
				</div>
				<SideNavFooter
					collapsed={navCollapsed}
					shellTheme={shellTheme}
				/>
			</div>
		</Sider>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, sideNavTheme } = theme;
	return {
		navCollapsed,
		sideNavTheme,
	};
};

export default connect(mapStateToProps)(SideNav);
